import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AppColors } from 'resources/AppColors';

function DuplicateMenuOption({ entity, showText }) {
  const navigate = useNavigate()

  function handleDuplicateContent() {
    navigate(`${entity.id}/duplicate`, { state: { entity } })
  }

  return (
    <Box onClick={handleDuplicateContent} p={"6px"} sx={{ width: "100%" }} >
      <IconButton>
        <ContentCopyIcon sx={{ fill: AppColors.PRIMARY }} />
        {showText &&
          <Typography variant="menu_list_text" >
            {showText}
          </Typography>
        }
      </IconButton>
    </Box>
  )
}

export default DuplicateMenuOption